import { ChevronDown, Home, Lock, LogOut, Maximize, Minimize, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { setBranchCode, setOpen } from '../../Redux/Services/headerSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall } from '../CommonComponents/CustomHooks';
import { CommonApiData, deleteCookie, virtualPath } from '../CommonComponents/EnvConfig';
import { AutoCompleteBoxNew } from '../CommonComponents/InputBox';
import { GetSession, RemoveSession } from '../CommonComponents/criptoUtils';

export const toggleFullScreen = (event, ID, setIsFullScreen, isFullScreen) => {
    if (!isFullScreen) {
        let element = document.documentElement;
        if (ID !== undefined && ID !== '') {
            element = document.getElementById(ID);
        }
        if (element) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
            element.style.overflow = 'auto';
            setIsFullScreen(true);
        }
    } else {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        document.body.style.overflow = 'auto';
        setIsFullScreen(false);
    }
};

const Header = () => {
    const dispatch = useDispatch();
    const open = useSelector((state) => state.header.open);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isDropdown, setIsDropdown] = useState(false);
    const userprofile = GetSession('localstorage', 'ProfilePic');
    const user = GetSession('cookies', 'user')
    const navigate = useNavigate();
    const data = CommonApiData();
    const [formData, setFormData] = useState({
        searchingNo: "",
        searchingType: "AWBNo"
    })
    const inputrefs = useRef([])
    const branch = useSelector((state) => state.header.branchCode);
    const Logout = async () => {
        let data = await ApiCall('/api/UserLogin/Logout', {});
        if (data.status === 'SUCCESS') {
            deleteCookie('user');
            RemoveSession("cookies", 'user');
            localStorage.removeItem('branch_value');
            localStorage.removeItem('branch_change');
            dispatch(setBranchCode(''));
            NotificationSound(data.status, data.message);
            navigate('/');
        }
    };

    useEffect(() => {
        document.body.classList.add('light');
    }, []);

    useEffect(() => {
        const savedBranch = localStorage.getItem('branch_value');
        if (savedBranch) {
            dispatch(setBranchCode(savedBranch));
        }
        else if (user?.loginBranch) {
            dispatch(setBranchCode(user.loginBranch));
        }
    }, []);
    useEffect(() => {
        if (!user?.token) {
            NotificationSound('EXPIRED', 'EXPIRED');
        }
    }, [user]);

    return (
        <nav className="sticky top-0 left-0 right-0 bg-white shadow-md md:z-40 z-10">
            <div className="flex items-center justify-between px-6 h-16">
                {/* Left Section - Logo & Navigation */}
                <div className="flex items-center gap-6">
                    {/* Logo */}
                    <div className="toggle-icon text-black" onClick={() => dispatch(setOpen(!open))}>
                        {open ? <PanelLeftClose /> : <PanelLeftOpen />}
                    </div>
                </div>
                <div className='flex gap-2'>
                    <div className="input-group input-group-sm w-auto">
                        <select
                            className="flex-grow-0"
                            id='txtSearchingType'
                            style={{ maxWidth: "90px" }}
                            value={formData.searchingType}
                            disabled
                            onChange={(e) => {
                                setFormData({ ...formData, searchingType: e.target.value });
                            }}
                        >
                            <option value="AWBNo">Docket No</option>
                        </select>

                        <input
                            type="text"
                            className="form-control"
                            id='txtSearchingText'
                            placeholder="Enter Docket No"
                            value={formData.searchingNo}
                            autoFocus
                            onChange={(e) => setFormData({ ...formData, searchingNo: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    if (formData.searchingNo === '') {
                                        NotificationSound('ERROR', 'Please enter AwbNo.!')
                                        return;
                                    }
                                    window.open(
                                        `${virtualPath}/Query/AwbNoQuery?SearchingNo=${formData.searchingNo}`,
                                        "_blank"
                                    );
                                    setFormData({ ...formData, searchingNo: "" });
                                }
                            }}
                        />
                    </div>

                    <AutoCompleteBoxNew
                        id="txtBranch"
                        label=""
                        placeholder=""
                        divclassname='w-64'
                        inputrefs={inputrefs}
                        autocompleteType="GetBranch"
                        value={branch || ''}

                        onChange={(event, newInputValue) => {
                            newInputValue = newInputValue || ''
                            if (event.type !== 'keydown') {
                                dispatch(setBranchCode(newInputValue || ''))
                                localStorage.setItem('branch_value', newInputValue || '')
                                localStorage.setItem('branch_change', Date.now())
                            }
                        }}
                    />
                </div>
                <div className="flex items-center gap-1">
                    <button
                        onClick={(event) => toggleFullScreen(event, '', setIsFullScreen, isFullScreen)}
                        className="p-2 hover:bg-white/10 rounded-lg transition-colors hidden lg:block"
                        title="Toggle Fullscreen"
                    >
                        {!isFullScreen ? (
                            <Maximize size={20} className="text-gray-300" />
                        ) : (
                            <Minimize size={20} className="text-gray-300" />
                        )}
                    </button>




                    {/* User Dropdown */}
                    <div className="relative">
                        <button
                            onClick={() => setIsDropdown(!isDropdown)}
                            className="flex items-center gap-3 px-3 py-2 hover:bg-white/10 rounded-lg transition-all group"
                        >
                            <div className="text-right hidden md:block">
                                <p className="text-sm font-semibold text-black flex items-center gap-2">
                                    <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                                    <span className='text-nowrap'> {data?.userName || '----'}</span>
                                </p>
                                {/*<p className="text-xs text-gray-400 text-nowrap">{data?.UserType || 'Administrator'}</p>*/}
                            </div>
                            <div className="relative ">
                                <img
                                    src={userprofile || "./images/avatar.png"}
                                    alt="user"
                                    className="w-9 h-9 rounded-full border-2 border-white/30 object-cover"
                                    onError={(e) => {
                                        e.target.src = `https://ui-avatars.com/api/?name=${data?.userName || "User"}&background=30667d&color=fff&bold=true`;
                                    }}
                                />
                                <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-primary-600"></div>
                            </div>
                            <ChevronDown
                                size={16}
                                className={`text-gray-300 transition-transform duration-200 ${isDropdown ? 'rotate-180' : ''}`}
                            />
                        </button>

                        {/* Dropdown Menu */}
                        {isDropdown && (
                            <>
                                <div
                                    className="fixed inset-0 z-40"
                                    onClick={() => setIsDropdown(false)}
                                ></div>
                                <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-2xl border border-gray-200 py-2 z-50 animate-fade-in">
                                    {/* User Info */}
                                    <div className="px-4 py-3 border-b border-gray-100">
                                        <div className="flex items-center gap-3">
                                            <img
                                                src={userprofile || "./images/avatar.png"}
                                                alt="user"
                                                className="w-12 h-12 rounded-full border-2 border-gray-200 object-cover"
                                                onError={(e) => {
                                                    e.target.src = `https://ui-avatars.com/api/?name=${data?.userName || "User"}&background=30667d&color=fff&bold=true`;
                                                }}
                                            />
                                            <div>
                                                <p className="text-sm font-bold text-gray-800">{data?.userName || '----'}</p>
                                                <p className="text-xs text-gray-500">{data?.loginUserCode || '----'}</p>
                                                {/*<p className="text-xs text-gray-400 mt-0.5">{data?.UserEmail || 'user@example.com'}</p>*/}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Menu Items */}
                                    <div className="py-2">
                                        <Link
                                            to="/Dashboard/Dashboard"
                                            className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors"
                                            onClick={() => setIsDropdown(false)}
                                        >
                                            <Home size={18} className="text-gray-600" />
                                            <span className="text-sm text-gray-700">Dashboard</span>
                                        </Link>

                                        <Link
                                            to="/User/ChangePassword"
                                            className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors"
                                            onClick={() => setIsDropdown(false)}
                                        >
                                            <Lock size={18} className="text-blueled" />
                                            <span className="text-sm text-gray-700">Change Password</span>
                                        </Link>
                                    </div>

                                    {/* Divider */}
                                    <div className="border-t border-gray-100 my-1"></div>

                                    {/* Logout */}
                                    <button
                                        onClick={() => {
                                            Logout();
                                            setIsDropdown(false);
                                        }}
                                        className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors w-full text-left group"
                                    >
                                        <div className="p-1.5 bg-red-50 rounded-lg group-hover:bg-red-100 transition-colors">
                                            <LogOut size={18} className="text-red-500" />
                                        </div>
                                        <div>
                                            <span className="text-sm font-medium text-gray-700">Logout</span>
                                            <p className="text-xs text-gray-500">Sign out from system</p>
                                        </div>
                                    </button>
                                </div>
                            </>
                        )}
                    </div>

                </div>
            </div>
        </nav>
    );
};

export default Header;